import { render, staticRenderFns } from "./MyMarketingObjectTable.vue?vue&type=template&id=5b1d4da6&scoped=true"
import script from "./MyMarketingObjectTable.vue?vue&type=script&lang=js"
export * from "./MyMarketingObjectTable.vue?vue&type=script&lang=js"
import style0 from "./MyMarketingObjectTable.vue?vue&type=style&index=0&id=5b1d4da6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b1d4da6",
  null
  
)

export default component.exports